import { Lock } from '@emotion-icons/boxicons-solid/Lock'

import { Colors } from 'src/components/theme'
import { UserTier } from 'src/common-services'
import { useTier } from 'src/hooks/use-tier'

type LockedFeatureProps = {
  isLocked?: boolean
  tier?: UserTier
  size?: number
}

export const LockedFeature = (props: LockedFeatureProps) => {
  const { isLocked, tier, size = 14 } = props
  const meetsTier = useTier(tier)

  if ((isLocked !== undefined && !isLocked) || (tier !== undefined && meetsTier)) {
    return null
  }

  return <Lock id="locked-feature" color={Colors.orangeDark} size={size} />
}
